import * as React from 'react';
import { useState, useEffect } from 'react';
import config from '../../config';
import StandardResetPassword from './standardResetPassword';

const { resetUrl } = config;

function ResetPassword() {
    const [error, setError] = useState('');
    const [resetAction, setResetAction] = useState('');

    useEffect(() => {
        const searchParams = new URL(window.location as any)?.searchParams;
        const err = searchParams.get('error') as string;
        setError(err);

        const token = searchParams.get('token') as string;
        const host = window.location.origin;
        const redirectErrorUrl = `${host}/reset`;
        const redirectSuccessUrl = `${host}/login`;
        const baseUrl = resetUrl;
        const action = `${baseUrl}${token}&redirect_success_url=${redirectSuccessUrl}`
            + `&redirect_error_url=${redirectErrorUrl}`;
        setResetAction(action);
    }, []);

    return (
        <StandardResetPassword error={error} resetAction={resetAction} />
    );
}

export default ResetPassword;
